import styles from "./PrintCardsModal.module.css";
import React, { useEffect, useState } from "react";
import { FaMinus, FaPlus, FaTrashCan } from "react-icons/fa6";
import {
  boosterQuantity,
  usePrintCartProvider,
} from "../../../context/PrintCartProvider";
import globalStyles from "../../../styles/globalStyles.module.css";
import quantityButtonsStyles from "../../Buttons/AddToCartButton/AddToCartButton.module.css";
import { FaPrint } from "react-icons/fa6";
import Booster from "../../Boosters/Booster";
import { useTranslation } from "react-i18next";
import {
  createStripeShippingSession,
  requestBoosterQuantity,
} from "../../../services/StripeServices";
import { getCardsForBooster } from "../../../services/BoosterServices";
import { useAlert } from "../../../context/AlertProvider";

export const PrintCardsModal: React.FC<{
  isOpen: boolean;
  handleClose: () => void;
}> = ({ isOpen, handleClose }) => {
  // const [isOpen, setIsOpen] = useState(false);
  const {
    items,
    removeFromCart,
    increaseItemQuantity,
    decreaseItemQuantity,
    resetCart,
  } = usePrintCartProvider();
  const [totalPrice, setTotalPrice] = useState<number>(0);
  const { t } = useTranslation();
  const { showAlert } = useAlert();

  useEffect(() => {
    const calculateTotalPrice = async () => {
      let totalPriceValue = 0;
      for (const item of items) {
        const res = await getCardsForBooster(item.booster.id);
        totalPriceValue +=
          item.quantity *
          res.length *
          Number(process.env.REACT_APP_CARD_PRINT_PRICE);
      }
      setTotalPrice(totalPriceValue);
    };

    calculateTotalPrice();
  }, [items]);

  const handleCheckout = async () => {
    try {
      const requestItems: requestBoosterQuantity[] = [];

      items.forEach((item: boosterQuantity) => {
        requestItems.push({
          boosterId: item.booster.id,
          quantity: item.quantity,
        });
      });

      const json = await createStripeShippingSession(requestItems);

      if (!json || !json.url) {
        console.error("Error creating Stripe session:", json);
        return;
      }

      const { url } = json;
      if (url) {
        window.location.href = url;
      }
    } catch (error) {
      resetCart();
      showAlert(error instanceof Error ? error.message : String(error));
    }
  };

  return (
    <>
      {isOpen && (
        <div className={styles.modalOverlay} onClick={handleClose}>
          <div className={styles.modal} onClick={(e) => e.stopPropagation()}>
            <h2>
              <FaPrint /> {t("print.label")}
            </h2>
            {items.length === 0 && <div>{t("noContent")}</div>}
            <div className={styles.itemContainer}>
              {items.map((item: boosterQuantity, index) => (
                <div key={index} className={styles.item}>
                  <div className={styles.boosterImage}>
                    <Booster booster={item.booster} isInStore={true} />
                  </div>
                  <div className={styles.priceContainer}>
                    <div className={styles.resumeContainer}>
                      <strong>{item.booster.name}</strong>
                      <p>
                        {item.nbCards *
                          Number(process.env.REACT_APP_CARD_PRINT_PRICE)}
                        €
                      </p>

                      <div
                        className={
                          quantityButtonsStyles.quantityButtonsContainer
                        }
                      >
                        <button
                          className={`${globalStyles.button} ${quantityButtonsStyles.minus}`}
                          onClick={() => decreaseItemQuantity(item)}
                        >
                          <FaMinus />
                        </button>
                        <div className={quantityButtonsStyles.quantityInput}>
                          {item.quantity}
                        </div>
                        <button
                          className={`${globalStyles.button} ${quantityButtonsStyles.plus}`}
                          onClick={() => increaseItemQuantity(item)}
                        >
                          <FaPlus />
                        </button>
                        <button
                          className={`${globalStyles.button} ${styles.trashButton}`}
                          onClick={() => removeFromCart(item.booster)}
                        >
                          <FaTrashCan />
                        </button>
                      </div>
                    </div>
                    <strong>
                      {item.quantity *
                        item.nbCards *
                        Number(process.env.REACT_APP_CARD_PRINT_PRICE)}
                      €
                    </strong>
                  </div>
                </div>
              ))}
            </div>

            <div className={styles.totalContainer}>
              <div className={styles.priceContainer}>
                <h4>{t("total")}</h4>
                <h2>{totalPrice}€</h2>
              </div>
              <button
                className={`${globalStyles.button} ${styles.checkoutButton}`}
                onClick={handleCheckout}
              >
                <strong>{t("checkout")}</strong>
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
};
